export default "__VITE_ASSET__Bk9wGxbh__"